<template>
  <wd-config-provider :themeVars="themeVars" theme="light">
    <slot />
    <wd-toast />
    <wd-message-box />
  </wd-config-provider>
</template>

<script lang="ts" setup>
import type { ConfigProviderThemeVars } from 'wot-design-uni'
const themeVars: ConfigProviderThemeVars = {
  buttonPrimaryBgColor: '#ea373d',
  buttonPrimaryColor: '#fff',
  checkboxCheckedColor: '#ea373d',
}
</script>
